<template lang="pug">
  #dashboard-health-age
    WtTitle(card-title) Health Age
    .has-text-grey Take our health and wellness survey to determine your 'Health Age' and to learn more about your health.
    br
    WtButton(
                color="primary"
                size="medium"
                @click.native="goToHraWebsite()"
              ) Find your health age
</template>

<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";

export default {
  name: "DashboardHra",

  components: {
    WtButton,
    WtTitle
  },
  methods: {
    async goToHraWebsite() {
      try {
        await this.axios.get("hra/sso").then(response => {
          if (response.status === 200) {
            window.open(response.data, "_blank", "noreferrer");
          } else {
            this.showErrorDialog();
          }
        });
      } catch (error) {
        this.showErrorDialog();
      }
    },
    showErrorDialog() {
      this.$buefy.dialog.alert({
        title: "Error!",
        type: "is-danger",
        message:
          "We were unable to log you into the HRA portal, please try again later or contact wellness@be-engaged.co."
      });
    }
  }
};
</script>

<style lang="sass" scoped></style>
